export default {
  title: '邀请申请工作',
  label: {
    job: '工作',
    subject: '主题',
    content: '内容'
  },
  btn: {
    invite: '邀请'
  },
  message: {
    inviteSuccess: '邀请成功',
    inviteNoEmailAccount: '该用户没有填写邮箱，我们暂时无法邀请该求职者。短信邀请正在紧张制作中，敬请期待！',
    inviteOverLimitTimes: '已经超过该用户可以邀请的上限，请过几天再来操作。',
    inviteFail: '邀请失败',
    atLeastOneJob: '请至少选择一个职位',
    noJob: '暂无其他职位可以邀请，请创建新的职位'
  }
}
